import * as tslib_1 from "tslib";
import { ErrorHandler, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { FlashMessagesService } from './services/flash-messages/flash-messages.service';
import { SpinnerService } from './services/spinner/spinner.service';
import { ClientAuthError } from 'msal';
var CustomErrorHandler = /** @class */ (function (_super) {
    tslib_1.__extends(CustomErrorHandler, _super);
    function CustomErrorHandler(injector) {
        var _this = 
        // The true parameter tells Angular to rethrow exceptions,
        // so operations like 'bootstrap' will result in an error when an error happens.
        // If we do not rethrow, bootstrap will always succeed.
        _super.call(this) || this;
        _this.injector = injector;
        return _this;
    }
    CustomErrorHandler.prototype.handleError = function (error) {
        _super.prototype.handleError.call(this, error);
        // NOTE: Force the application to logout and login again if it has the intermittent ClientAuthError
        // in order to renew the refresh tokens
        var flashMessagesService = this.injector.get(FlashMessagesService);
        var spinnerService = this.injector.get(SpinnerService);
        var router = this.injector.get(Router);
        var location = this.injector.get(Location);
        var titleService = this.injector.get(Title);
        var ngZone = this.injector.get(NgZone);
        // Check if the current history state indicates this was a retry attempt
        var isRetryAttempt = false;
        if (history.state && history.state.isRetry) {
            isRetryAttempt = true;
        }
        if (error instanceof ClientAuthError) {
            flashMessagesService.clearAll();
            spinnerService.start();
            window.location.href = window.location.origin;
        }
        else {
            var returnUrl = location.path();
            var returnTitle = titleService.getTitle();
            // State for standard info (passed via state still reliable for URL/Title)
            var errorState_1 = { returnUrl: returnUrl, returnTitle: returnTitle };
            // Query Params for the persistent flag
            var errorQueryParams_1 = {};
            if (isRetryAttempt) {
                errorQueryParams_1['persistent'] = 'true'; // Add as query parameter
            }
            ngZone.run(function () {
                // Navigate with state for URL/Title and queryParams for persistent flag
                router.navigate(['/error'], {
                    state: errorState_1,
                    queryParams: errorQueryParams_1,
                    replaceUrl: isRetryAttempt
                });
            });
            spinnerService.reset();
        }
        // HACK: Explicitly tell NG2 to redraw (so we can actually see our message).
        // See: https://stackoverflow.com/questions/35105374/how-to-force-a-components-re-rendering-in-angular-2
        // TODO: FlashMessages should probably be Observable so we can avoid needing this hack.
        // const applicationRef = this.injector.get(ApplicationRef);
        // applicationRef.tick();
    };
    return CustomErrorHandler;
}(ErrorHandler));
export { CustomErrorHandler };
